import React from 'react';

import { MediaPanel, TabView } from '../../components';

import './MediaCollection.scss';

import { ICategoryList, IMedia } from '../../utils/models';
import { hasProgramAssets } from '../../utils/networkMap';

export interface IMediaCollectionProps {
  tabs: string[];
  items: IMedia[];
  networkName?: string;
  sortFn?: (items) => any[];
  pageSize?: number;
  showTitle: boolean;
  categories?: ICategoryList;
}

const MediaCollection = ({
  categories,
  tabs,
  items,
  networkName = '',
  sortFn,
  pageSize = 100,
  showTitle = true,
}: IMediaCollectionProps) => {
  const movies = new Set();
  const tvShows = new Set();

  let panels: any[] = [];

  const getPanelTitle = () => {
    if (movies.size) return 'Movies';
    if (tvShows.size) return 'TV Shows';
    return 'All';
  };

  const getUniqueItems = () => {
    const uniqueItems = [...(new Set(items) as unknown as IMedia[])];
    const filteredItems = uniqueItems.filter((item) => {
      // Only return Program asset types if they are part of Music Choice
      return (
        (item.offer &&
          hasProgramAssets.includes(item?.offer?.[0]?.providerId)) ||
        item?.assetType !== 'Program'
      );
    });
    return filteredItems;
  };

  if (categories) {
    panels = tabs.map((tab) => {
      return (
        <MediaPanel
          key={tab}
          title={tab}
          items={[...(new Set(categories[tab]) as unknown as IMedia[])]}
          networkName={networkName}
          sortFn={sortFn}
          pageSize={pageSize}
          showTitle={showTitle}
        />
      );
    });
  } else {
    // split into panels for movies/tv shows and both
    for (const item of items) {
      if (item.assetType !== 'Program') {
        item.assetType === 'Movie' ? movies.add(item) : tvShows.add(item);
      }
    }
    panels = [
      <MediaPanel
        key="all"
        title="All"
        items={[...(new Set(items) as unknown as IMedia[])].filter(
          (item) => item && item.assetType !== 'Program'
        )}
        networkName={networkName}
        sortFn={sortFn}
        pageSize={pageSize}
        showTitle={showTitle}
      />,
      <MediaPanel
        key="movies"
        title="Movies"
        items={[...(movies as unknown as IMedia[])]}
        networkName={networkName}
        sortFn={sortFn}
        pageSize={pageSize}
        showTitle={showTitle}
      />,
      <MediaPanel
        key="tvShows"
        title="TV Shows"
        items={[...(tvShows as unknown as IMedia[])]}
        networkName={networkName}
        sortFn={sortFn}
        pageSize={pageSize}
        showTitle={showTitle}
      />,
    ];
  }

  return (movies.size && tvShows.size) || categories ? (
    <TabView tabs={tabs} panels={panels} />
  ) : (
    <MediaPanel
      title={getPanelTitle()}
      items={getUniqueItems()}
      networkName={networkName}
      sortFn={sortFn}
      pageSize={pageSize}
      showTitle={showTitle}
    />
  );
};

export default MediaCollection;
